module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_scheda-b7e2775043dda14a0fd6a3653e8be22d.svg";